module.exports = __webpack_public_path__ + "img/diamont.35fb78f8.svg";